import React from "react";
import { Reveal } from "../ui/Reveal";
import { CtaButton } from "../ui/CtaButton";
import { CheckoutTrust } from "../ui/CheckoutTrust";
import { CountdownDisplay } from "../ui/CountdownDisplay";
import { CHECKOUT_URL, PRICE_TODAY } from "../../data/offer";
import { mockupUrl } from "../../data/images";
export function FinalCta() {
  return <section className="bg-cocoa-dark py-20 text-cream lg:py-28" data-id="element-163" data-mp="1sm8a3cgg54al">
      <div className="mx-auto max-w-3xl px-5 text-center" data-id="element-164" data-mp="1en8hjtptc595">
        <Reveal data-id="element-165" data-mp="1ipwtwbdqjuav">
          <img src={mockupUrl} alt="Pack Dulce Saludable" className="mx-auto w-56 rounded-3xl border-[6px] border-cream shadow-2xl sm:w-64" data-id="element-166" data-mp="1iqen0z53psek" />
          <h2 className="mt-10 font-display text-4xl font-bold leading-tight sm:text-5xl" data-id="element-167" data-mp="14rorvp1ue2su">
            Entonces... ¿Cuál Es Tu <span className="text-gold-light" data-id="element-168" data-mp="19rb35sy418z0">Decisión</span>?
          </h2>
        </Reveal>
        <Reveal delay={0.05} className="mt-10" data-id="element-169" data-mp="2z4y59rxie8gd">
          <CountdownDisplay data-id="element-170" data-mp="343re371upba7" />
        </Reveal>
        <Reveal delay={0.1} className="mt-10" data-id="element-171" data-mp="342gcndvvofm9">
          <CtaButton href={CHECKOUT_URL} label="Sí, estoy lista — quiero el pack" sublabel={`Pack Dulce Saludable por $${PRICE_TODAY}`} data-id="element-172" data-mp="28lbsbsgn37t" />
          <p className="mt-4 text-sm text-cream/70" data-id="element-173" data-mp="3tewjurvw148n">Acceso inmediato. Garantía de 30 días. Soporte por email. Cancelación fácil si no te funciona.</p>
          <CheckoutTrust tone="dark" data-id="element-174" data-mp="703g99tozlxj" />
        </Reveal>
      </div>
    </section>;
}